<template>
  <div class="category-products" :class="{ 'category-products--showcase': isShowcase }">
    <b-overlay :show="loading">
      <div :class="isShowcase ? 'category-products__grid' : 'row'" style="min-height: 250px">
        <div
          v-for="product in products"
          :key="product._id"
          :class="isShowcase ? 'category-products__item' : 'col-6 col-xs-6 col-md product-item'"
        >
          <single-product
            :data="product"
            :product-template="isShowcase ? 'category-showcase' : ''"
          />
        </div>
        <slot></slot>
      </div>
    </b-overlay>
  </div>
</template>

<script>
//import singleProduct from "../components/singleProduct";
const singleProduct = () => import(/* webpackChunkName: "singleproduct" */"../components/singleProduct.vue");

export default {
  components: {
    singleProduct,
  },
  props: {
    id: { type: [String, Number], default: null },
    params: { type: String, default: "" },
    categoryProductTemplate: { type: String, default: "showcase" },
  },
  data() {
    return {
      products: [],
      loading: true,
    };
  },
  computed: {
    isShowcase() {
      return this.categoryProductTemplate !== "classic";
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      let { _id } = this.$store.state.info;
      let cid = this.id;

      let query = {
        order: "createdAt",
        limit: 4,
      };
      if (cid) query.category = cid;
      if (this.params) {
        let params = this.params.split(",");
        params.forEach((p) => {
          let [key, value] = p.split("=");
          query[key] = value;
        });
      }

      const u = new URLSearchParams(query).toString();

      this.$http
        .get(`${_id}/product?${u}`)
        .then((res) => {
          this.products = Array.isArray(res.data.data) ? res.data.data : [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.category-products--showcase {
  padding: clamp(8px, 2vw, 28px) clamp(4px, 1.5vw, 20px);
}

.category-products__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(14px, 2vw, 28px);
  align-items: stretch;
}

.category-products__item {
  min-width: 0;
}

@media (max-width: 991.98px) {
  .category-products__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .category-products--showcase {
    padding: 8px 4px 18px;
  }

  .category-products__grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
}
</style>
